import React, { useEffect, useMemo, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useSnackbar } from 'notistack';
import { useFormik } from 'formik';
import {
    useGridApiRef,
    DataGridPro,
} from '@mui/x-data-grid-pro';
import {
    Box,
    TextField,
    MenuItem,
    Button
} from '@mui/material';
import koLocale from 'date-fns/locale/ko';
import DateAdapter from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import DatePicker from '@mui/lab/DatePicker';
import * as yup from 'yup';
import dayjs from 'dayjs';
import StockTypChip from '../../../components/common/datagrid/StockTypChip';
import { listInventoryHistory, unloadInventoryHistory } from '../../../modules/inventoryModule/invHistory';



const StockHistoryListContainer = ({ onSelectedData }) => {
    const dispatch = useDispatch();
    const { enqueueSnackbar } = useSnackbar();
    const [pageSize, setPageSize] = React.useState(50);
    const [searchTyp, setSearchTyp] = useState("")
    const [searchKeyword, setSearchKeyword] = useState("productNm");
    const [searchWords, setSearchWords] = useState(null);
    const [searchStrtDt, setSearchStrtDt] = useState(null);
    const [searchEndDt, setSearchEndDt] = useState(null);

    const { history, error, loading } = useSelector(
        ({ inventoryModule, loading }) => ({
            history: inventoryModule.invHistory.history,
            error: inventoryModule.invHistory.error,
            loading: loading['inventory/LIST_INV_HISTORY'],
        }),
    );

    // 컴포넌트 마운트 후 list 데이터 요청
    useEffect(() => {
        dispatch(listInventoryHistory());
        return () => unloadInventoryHistory();
    }, []);


    const onChangeDate = (newValue, name) => {
        formik.setFieldValue(name, newValue);
    };




    const searchList = (values) => {
        let searchData = {
            [values.searchKeyword]: values.searchWords,
        };

        const startDate =
            values.searchStrtDt !== null && values.searchStrtDt !== ''
                ? dayjs(values.searchStrtDt).format('YYYY-MM-DD')
                : '';
        const endDate =
            values.searchEndDt !== null && values.searchEndDt !== ''
                ? dayjs(values.searchEndDt).format('YYYY-MM-DD')
                : '';

        setSearchKeyword(values.searchKeyword);
        setSearchWords(values.searchWords);

        //search

    }

    const initialValues = {
        searchTyp: searchTyp,
        searchKeyword: searchKeyword,
        searchWords: searchWords,
        searchStrtDt: searchStrtDt,
        searchEndDt: searchEndDt,
    };


    const validationSchema = yup.object({
        searchKeyword: yup.string('').nullable(),
        searchWords: yup.string('').trim().nullable(),
        searchStrtDt: yup.date().nullable().default(undefined),
        searchEndDt: yup
            .date()
            .min(yup.ref('searchStrtDt'), '등록 종료일을 확인하세요')
            .when('searchStrtDt', (searchStrtDt, schema) => {
                if (searchStrtDt) return schema.required('등록 종료일을 입력하세요');
            })
            .nullable()
            .default(undefined),
    });

    const formik = useFormik({
        initialValues: initialValues,
        enableReinitialize: true,
        validationSchema: validationSchema,
        onSubmit: (values, { setSubmitting }) => {
            setSubmitting(true);

            setTimeout(() => {
                searchList(values);
                setSubmitting(false);
            }, 1000);
        },
    });


    const apiRef = useGridApiRef();



    const columns = useMemo(
        () => [
            {
                field: 'id',
                headerName: 'ID',
                hide: true,
                type: 'string',
                editable: false,
            },

            {
                field: 'trnUuid',
                headerName: '이력ID',
                hide: true,
                type: 'string',
                editable: false,
            },
            {
                field: 'trnTyp',
                headerName: '타입',
                minWidth: 100,
                flex: 0.5,
                type: 'string',
                editable: false,
                renderCell: StockTypChip
            },
            {
                field: 'trnNm',
                headerName: '신청명',
                minWidth: 300,
                flex: 1,
                type: 'string',
                editable: false,
            },
            // {
            //     field: 'trnDesc',
            //     headerName: '사유',
            //     minWidth: 200,
            //     flex: 1,
            //     type: 'string',
            //     editable: false,
            // },

            {
                field: 'crtNm',
                headerName: '등록자',
                minWidth: 80,
                flex: 1,
                type: 'string',
                editable: false,
            },

            {
                field: 'crtDt',
                headerName: '등록일',
                minWidth: 200,
                flex: 1,
                type: 'dateTime',
                editable: false,
            },

        ],
        [],
    );


    const handleRowClick = (param) => {
        onSelectedData(param.row)
    };


    return (
        <Box>
            <Box sx={{ my: 1, display: 'flex', justifyContent: ' space-between', alignItems: 'center' }}>
                <Box
                    component="form"
                    noValidate
                    autoComplete="off"
                    sx={{
                        flexGrow: 1,
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'flex-end',
                        alignItems: 'center',
                        mr: 2,
                    }}
                    onSubmit={formik.handleSubmit}
                >
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: 'row',
                            justifyContent: 'flex-start',
                            alignItems: 'center',
                            '& > :not(style)': { m: 1, width: '25ch' },
                        }}
                    >
                        <TextField
                            variant="standard"
                            required={false}
                            select
                            id="searchTyp"
                            name="searchTyp"
                            label="타입"
                            value={formik.values.searchTyp}
                            onChange={formik.handleChange}
                            error={
                                formik.touched.searchTyp &&
                                Boolean(formik.errors.searchTyp)
                            }
                            helperText={
                                formik.touched.searchTyp && formik.errors.searchTyp
                            }
                        >
                            <MenuItem value="">타입</MenuItem>
                            <MenuItem value="I">입고</MenuItem>
                            <MenuItem value="O">출고</MenuItem>
                            <MenuItem value="D">폐기</MenuItem>
                        </TextField>
                        <TextField
                            variant="standard"
                            required={false}
                            select
                            id="searchKeyword"
                            name="searchKeyword"
                            label="검색키워드"
                            value={formik.values.searchKeyword}
                            onChange={formik.handleChange}
                            error={
                                formik.touched.searchKeyword &&
                                Boolean(formik.errors.searchKeyword)
                            }
                            helperText={
                                formik.touched.searchKeyword && formik.errors.searchKeyword
                            }
                        >
                            {/* <MenuItem value="">검색키워드</MenuItem> */}
                            <MenuItem value="productNm">제품명</MenuItem>
                            <MenuItem value="desc">사유</MenuItem>
                        </TextField>
                        <TextField
                            variant="standard"
                            required={false}
                            id="searchWords"
                            name="searchWords"
                            label="검색어"
                            onChange={formik.handleChange}
                            error={
                                formik.touched.searchWords && Boolean(formik.errors.searchWords)
                            }
                            helperText={
                                formik.touched.searchWords && formik.errors.searchWords
                            }
                        />
                    </Box>
                    <Box>
                        <LocalizationProvider dateAdapter={DateAdapter} locale={koLocale}>
                            <DatePicker
                                label="등록 시작일"
                                inputFormat={'yyyy-MM-dd'}
                                mask={'____-__-__'}
                                id="searchStrtDt"
                                name="searchStrtDt"
                                value={searchStrtDt}
                                onChange={(newValue) => {
                                    setSearchStrtDt(newValue);
                                    onChangeDate(newValue, 'searchStrtDt');
                                }}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        variant="standard"
                                        fullWidth
                                        error={
                                            formik.touched.searchStrtDt &&
                                            Boolean(formik.errors.searchStrtDt)
                                        }
                                        helperText={
                                            formik.touched.searchStrtDt && formik.errors.searchStrtDt
                                        }
                                    />
                                )}
                            />
                        </LocalizationProvider>
                    </Box>
                    <Box sx={{ mx: 2 }}>
                        <LocalizationProvider dateAdapter={DateAdapter} locale={koLocale}>
                            <DatePicker
                                label="등록 종료일"
                                inputFormat={'yyyy-MM-dd'}
                                mask={'____-__-__'}
                                id="searchEndDt"
                                name="searchEndDt"
                                value={searchEndDt}
                                onChange={(newValue) => {
                                    setSearchEndDt(newValue);
                                    onChangeDate(newValue, 'searchEndDt');
                                }}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        variant="standard"
                                        fullWidth
                                        error={
                                            formik.touched.searchEndDt &&
                                            Boolean(formik.errors.searchEndDt)
                                        }
                                        helperText={
                                            formik.touched.searchEndDt && formik.errors.searchEndDt
                                        }
                                    />
                                )}
                            />
                        </LocalizationProvider>
                    </Box>
                    <Box>
                        <Button
                            type="submit"
                            color="info"
                            variant="contained"
                            disabled={formik.isSubmitting}
                        >
                            검색
                        </Button>
                    </Box>
                </Box>
            </Box>
            <div style={{ display: 'flex', height: 'calc(100vh - 320px)' }}>
                <div style={{ flexGrow: 1 }}>
                    <DataGridPro
                        apiRef={apiRef}
                        rows={history}
                        columns={columns}
                        loading={loading}
                        onRowClick={handleRowClick}
                        pageSize={pageSize}
                        onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                        rowsPerPageOptions={[5, 10, 20, 50, 100]}
                        pagination
                    />
                </div>
            </div>
        </Box>

    )
}

export default StockHistoryListContainer